import {
  Card,
  ProductInfo,
  ProductNameContainer,
  ProductDescription,
  StyledDivider,
} from "./styles";
import { FreePlanProps } from "./PriceBreakdown.types";
import { Typography } from "@mui/material";
import { PartnerCard } from "../PartnerCard";

export const FreePlanPriceBreakdown = (props: FreePlanProps) => {
  const { productName, productDescription, partner, hideMarketingCopy } =
    props;

  return (
    <Card>
      {!hideMarketingCopy && (
        <ProductInfo>
          <ProductNameContainer>
            <Typography>{productName}</Typography>
          </ProductNameContainer>
          {!!productDescription && (
            <ProductDescription>{productDescription}</ProductDescription>
          )}
        </ProductInfo>
      )}

      {!!partner && (
        <>
          {!hideMarketingCopy && <StyledDivider sx={{ margin: "0.5rem 1rem" }} />}
          <PartnerCard partner={partner} />
        </>
      )}
    </Card>
  );
};
